import React from "react";

type Props = {};

const Dashboard = (props: Props) => {
    return <div>dashboard</div>;
};

export default Dashboard;
